module.exports = __webpack_public_path__ + "img/whisky-banner-1-small.e66e9ace.jpg";